import image3 from "../Image/jobfind.png"
import image1 from "../Image/beu.png"
import image2 from "../Image/dapp.png"
import image4 from "../Image/khao.png"
import image5 from "../Image/kp.png"
import image6 from "../Image/vercel-icon.png"
import image7 from "../Image/git-icon.png"
import image8 from "../Image/pp.png"
import image9 from "../Image/talentf.png"
import imagenote1 from "../Image/imagenote.png"
import imagest2 from "../Image/imagest.png"
import imageath3 from "../Image/imageath.png"
import image11 from "../Image/image11.png"
import image12 from "../Image/image12.png"
import image13 from "../Image/image13.png"
import image14 from  "../Image/2025-11-25 21_21_46-tiny URL - Brave.png"

export const Bio = {
    name: "Vikash Sinha",
    roles: [
      "Web Developer",
      "full stack Developer",
      "Programmer",
        "problem-solver"
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/vikash000x",
    resume:
      "https://drive.google.com/file/d/1ERWnezPThZOfnx9CMc-VqF2vDXqrFK1d/view?usp=drive_link",
    linkedin: "https://www.linkedin.com/in/vikash-sinha-215000259/",
    twitter: "https://x.com/vikash_sinha_",
    insta: "https://www.instagram.com/niharchandra007?igsh=Znpnc29oa2FvZHZx",
    facebook: "https://www.facebook.com/nihar.chandra.31",
    leetcode: "https://leetcode.com/u/vikash_sinha/",
    codechef: "https://www.codechef.com/users/vikash000x",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        // {
        //   name: "TypeScript",
        //   image:
        //     "https://cdn.iconscout.com/icon/free/png-256/free-typescript-3521774-2945272.png?f=webp",
        // },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Tailwind",
          image:
            "https://pbs.twimg.com/profile_images/1730334391501488129/G0R0sjHH_400x400.jpg",
        },
      ],
    },
  {
  title: "Backend",
  skills: [
    {
      name: "Node.js",
      image: "https://nodejs.org/static/images/logo.svg",
    },
    {
      name: "Spring Boot",
      image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
    },
    {
      name: "Kafka",
      image: "https://www.vectorlogo.zone/logos/apache_kafka/apache_kafka-icon.svg",
    },
    {
      name: "Inngest",
      image: "https://avatars.githubusercontent.com/u/122227103?s=200&v=4",
    },
    {
      name: "Prisma",
      image: "https://raw.githubusercontent.com/prisma/presskit/master/Assets/Prisma-LightSymbol.png",
    },
    {
      name: "Clerk",
      image: "https://avatars.githubusercontent.com/u/105279441?s=200&v=4",
    }
  ]
},
{
  title: "Database",
  skills: [
    {
      name: "PostgreSQL",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg",
    },
    {
      name: "NeonDB",
      image: "https://avatars.githubusercontent.com/u/108468352?s=200&v=4",
    },
    {
      name: "MongoDB",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    },
    {
      name: "Supabase",
      image: "https://www.vectorlogo.zone/logos/supabase/supabase-icon.svg",
    }
  ]
},
    {
      title: "Blockchain",
      skills: [
        {
          name: "Solidity",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "ether.js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Hardhat",
          image:
            "data:image/png;base64,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",
        },
        
        {
          name: "Remix IDE",
          image:
            "data:image/png;base64,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",
        },
        
        
      ],
    },
      {
  title: "LLM & Automation",
  skills: [
    {
      name: "LangChain",
      image: "https://raw.githubusercontent.com/langchain-ai/langchain/main/docs/static/img/logo.svg",
    },
    {
      name: "Vector Databases",
      image: "https://upload.wikimedia.org/wikipedia/commons/4/46/Database-icon.png", // generic DB icon
    },
    {
      name: "Pinecone",
      image: "https://avatars.githubusercontent.com/u/78085539?s=200&v=4",
    },
    {
      name: "Chroma DB",
      image: "https://docs.trychroma.com/img/chroma-logo-dark.svg",
    },
    {
      name: "RAG (Retrieval-Augmented Generation)",
      image: "https://cdn-icons-png.flaticon.com/512/3739/3739779.png", // abstract concept icon
    },
    {
      name: "LLM Agents",
      image: "https://avatars.githubusercontent.com/u/154170098?s=200&v=4", // Autogen-style icon
    },
    {
      name: "Prompt Engineering",
      image: "https://cdn-icons-png.flaticon.com/512/1082/1082810.png",
    },
    {
      name: "OpenAI API",
      image: "https://cdn.worldvectorlogo.com/logos/openai-icon-2021.svg",
    },
    {
      name: "Gemini",
      image: "https://avatars.githubusercontent.com/u/125004865?s=200&v=4", // Google GenAI icon
    },
  ],
},

    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:image7,
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Vercel",
          image:image6,
        },
        
        // {
        //   name: "Figma",
        //   image:
        //     "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
        // },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
      role: "DevOps & Fullstack Engineering Intern",
      company: "Flipr Inovations Pvt. Ltd.",
      date: "Aug 2023 - July 2023",
      desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
      skills: [
        "Docker",
        "Terraform",
        "AWS",
        "EC2",
        "Portainer",
        "Nginx",
        "JavaScript",
        "TypeScript",
        "Node Js",
        " Next Js",
      ],
      doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
      role: "Frontend Engineer Intern",
      company: "Neurobit",
      date: "June 2023 - Present",
      desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
      skills: [
        "ReactJS",
        "Redux",
        "NodeJs",
        "Material UI",
        "HTML",
        "CSS",
        "JavaScript",
      ],
      doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
    },
    {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
      role: "Fullstack Externship",
      company: "Flipr",
      date: "June 2023 - July 2023",
      desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
      skills: [
        "ReactJS",
        "Redux",
        "NodeJs",
        "Material UI",
        "HTML",
        "CSS",
        "JavaScript",
        "Docker",
        "AWS",
        "MongoDB",
      ],
    },
    {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
      role: "Open Source Contributor ",
      company: "GirlScript Summer of Code",
      date: "May 2023 - Present",
      desc: "Contributing to different open-source projects and learn from industry experts",
      doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    },
    {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
      role: "Android Developer",
      company: "DSC KIIT",
      date: "Nov2021 - Present",
      desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
      skills: [
        "Leadership",
        "Mobile Application Development",
        "Kotlin",
        "XML",
        "Figma",
      ],
    },
    {
      id: 4,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
      role: "Android Developer Intern",
      company: "Rudraksha Welffare Foundation",
      date: "June 2021 - Oct 2021",
      desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
      skills: [
        "Android",
        "Java",
        "Kotlin",
        "XML",
        "Node Js",
        "Cloud Firestore",
        "Firebase",
        "Figma",
      ],
      doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
    },
  ];
  
  
  
  export const projects = [
    {
      id: 0,
      title: "BEU - College Club Website",
      date: "Dec 2024",
      bg:"bg-slate-900 hover:bg-gradient-to-t from-black via-black/30 to-slate-500 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
      description:
        "A platform for students of Bihar Engineering University to explore and participate in college clubs, events, and activities, fostering collaboration and engagement. The website features a user-friendly interface, secure authentication, and real-time updates on club activities and events.",
      image:image1,
      tags: [
        "React JS ",
        "Tailwind",
        "Mongo DB",
        "Express",
        "Redux"

      ],
      category: "web",
      github: "https://github.com/vikash000x/BEU_Group_Prj",
      webapp: "https://beu-campus-connect.vercel.app/",
    },
      {
  id: 1,
  title: "Project Management Platform",
  date: "Nov 2025",
  bg: "bg-slate-900 hover:bg-gradient-to-t from-black via-black/30 to-slate-500 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500 hover:scale-105",
  description:
    "A powerful workspace & project management platform with multi-workspace support, task assignment, analytics dashboard, real-time collaboration, webhook automation.",
  image: image11, // Replace with your actual image import
  tags: [
    "React.js",
  
    "Redux Toolkit",
    "Clerk Auth",
    "Inngest",
    
    "Express",
    "NeonDB",
    "Prisma ORM"
  ],
  category: "web",
  github: "https://github.com/vikash000x/workflow-management",
  webapp: "https://workflow-management-hpsn.vercel.app/"
},
      {
  id: 2,
  title: "AI Stock Trading Platform",
  date: "Oct 2025" ,
  bg: "bg-slate-900 hover:bg-gradient-to-t from-black via-black/30 to-slate-500 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500 hover:scale-105",
  description:
    "AI-powered real-time stock market application. Track real-time stock prices, explore company insights, manage watchlists, and receive automated alerts, AI summaries.",
  image: image12, // replace with your imported image
  tags: [
    "Next.js",
     "Coderabbit",
    
    "Better Auth",
    "Inngest",
    "MongoDB"
   
  ],
  category: "web",
  github: "https://github.com/vikash000x/stock_trading_app",
  webapp: "https://stock-trading-app-two.vercel.app/",
},{
  id: 3,
  title: "Social Media Platform",
  date: "2024",
  bg: "bg-slate-900 hover:bg-gradient-to-t from-black via-black/30 to-slate-500 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500 hover:scale-105",
  description:
    "A modern and fully responsive social media platform supporting posts, comments, media uploads, authentication, role-based access, and real-time interactions.",
  image: image13, // <-- replace with your image import
  tags: [
    "Next.js",
    "React Query",
    "Prisma",
    "Supabase",
    "Clerk",
    "Cloudinary",
    "Context API",
    "Ant Design"
  ],
  category: "web",
  github: "https://github.com/vikash000x/social-media",
  webapp: "https://social-media-qtak6t59z-vikash-sinhas-projects.vercel.app/"
},
      {
  id: 4,
  title: "TinyURL",
  date: "2025",
  bg: "bg-slate-900 hover:bg-gradient-to-t from-black via-black/30 to-slate-500 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500 hover:scale-105",
  description:
    "TinyURL is a full-stack application that allows users to shorten long URLs, manage them securely, and analyze click statistics",
  image: image14, // <-- replace with your image import
  tags: [
    "React.js",

      "nodemailer",
     
    "Prisma",
    "neondb",
   
    "express.js",
    "Context API"
    
  ],
  category: "web",
  github: "https://github.com/vikash000x/tinyURL",
  webapp: "https://tiny-url-ruddy.vercel.app/"
},


    {
      id: 5,
      title: "Khaoo peeyo",
      date: "Jun 2023 - June 2023",
      bg:"bg-slate-900 hover:bg-gradient-to-t from-black via-blue-800/30 to-sky-600/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
      description:
        "Khao Peeyo is a food delivery app that connects users with local restaurants. Users can browse menus, place orders, and track deliveries in real-time. The app features a user-friendly interface, secure payment options, and smart recommendations based on user preferences.",
      image:image4,
      tags:[
        "React JS ",
        "Tailwind",
        "Redux"
      ],
      category: "web",
      github: "https://github.com/vikash000x/Khao-peeyo",
      webapp: "https://khao-peeyo.vercel.app/",
    },
    {
      id: 6,
      title: "job finder",
      date: "Apr 2023 - May 2023",
      bg:"bg-slate-900 hover:bg-gradient-to-t from-black via-purple-800/50 to-purple-600/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
      description:
        " A job portal that enables recruiters to post jobs and candidates to apply, featuring an intuitive interface and smart recommendations. Users can create profiles, upload resumes, and search for jobs based on location, salary, and experience.",
      image:image3,
      tags:[
        "React JS ",
        "Tailwind",
        "Redux",
        "Mongo DB"
      ],
      category: "web",
      github: "https://github.com/vikash000x/job-finder",
      webapp: "https://job-finder-kzmj.onrender.com/",
      
    },
    {
      id: 7,
      title: "Krypt Exchange",
      date: "july 2024 - august 2024",
      bg:"bg-slate-900 hover:bg-gradient-to-t from-black via-sky-800/50 to-sky-600/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
      description:
        " A decentralized exchange (DEX) is a peer-to-peer (P2P) marketplace that connects cryptocurrency buyers and sellers. In contrast to centralized exchanges (CEXs), decentralized platforms are non-custodial, meaning a user remains in control of their private keys when transacting on a DEX.",
      image:image5,
      tags:  ["Solidity","hardhat",  "ether.js", "React","Rimix IDE"],
      category: "blockchain app",
      github: "https://github.com/vikash000x/krypt_exchange",
      webapp: "https://crypt-exchange-venp.vercel.app/",
    },
   
   
    {
      id: 8,
      title: "PixelPort",
      date: "jan 2025 - feb 2025",
      bg:"bg-slate-900 hover:bg-gradient-to-t from-black via-red-800/60 to-red-600/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
      description:
        "A creative marketplace for digital artists and designers to showcase, sell, and collaborate on artwork in a dynamic online space. Users can create a profile, upload their work, and connect with other artists.",
      image:image8,
      tags: ["Solidity","hardhat",  "ether.js", "React","Rimix IDE"],
      category: "blockchain app",
      github: "https://github.com/vikash000x/PixelPort/tree/main",
      webapp: "https://pixel-port-one.vercel.app/",
    },
    
    
    
    {
      id: 9,
      title: "Bright-Fund",
      date: "jan 2025 - feb 2025",
      bg:"bg-slate-900 hover:bg-gradient-to-t from-black via-orange-700/70 to-orange-500/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
      description:
        "A crowdfunding platform that enables users to raise funds for innovative projects, social causes, and startups through community-driven support. Users can create campaigns, share their stories, and receive donations from supporters.",
      image:image2,
      tags: ["Solidity","hardhat",  "ether.js", "React","Rimix IDE"],
      category: "blockchain app",
      github: "https://github.com/vikash000x/BrightFund",
      webapp: "https://bright-fund.vercel.app/",
    },
      {
  id: 10,
  title: "AI Note App",
  date: "Apr 2024 - Jun 2024",
  bg: "bg-slate-900 hover:bg-gradient-to-t from-black via-indigo-700/70 to-indigo-500/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
  description: "An AI-powered note-taking app that helps users organize, summarize, and manage their notes efficiently. Integrates with GPT for smart suggestions and search.",
  image: imagenote1,
  tags: ["TypeScript", "Next.js", "OpenAI API", "Pinecone", "TailwindCSS", "clerk"],
  category: "AI app",
  github: "https://github.com/vikash000x/ai-note-app",
  webapp: "https://ai-note-app-rosy.vercel.app/",
},
      {
  id: 11,
  title: "AIthelete",
  date: "Apr 2024 - Jun 2024",
  bg: "bg-slate-900 hover:bg-gradient-to-t from-black via-indigo-700/70 to-indigo-500/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500 hover:scale-105 ",
  description: "An AI-powered training agent that crafts personalized workout plans, delivers detailed feedback, and offers actionable recommendations. Built with LangChain and Next.js, AIthelete adapts to your fitness level using advanced AI for optimal progress.",
  image: imageath3, // Replace with your actual image import or path
  tags: ["TypeScript", "Next.js", "LangChain", "OpenAI API", "TailwindCSS"],
  category: "AI app",
  github: "https://github.com/vikash000x/AI_athelete",
  webapp: "https://ai-athelete.vercel.app/", // Replace with your deployed app URL if available
},  {
  id: 12,
  title: "new_stAI_thon",
  date: "Jun 2024 - Present",
  bg: "bg-slate-900 hover:bg-gradient-to-t from-black via-indigo-700/70 to-indigo-500/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500 hover:scale-105 ",
  description: "An advanced analytics tool that leverages the Gemini GenAI model and SerpAPI to identify companies providing services or partnering with a specified client. Features automated web scraping, AI-powered data extraction, and persistent storage for efficient insights.",
  image: imagest2, // Replace with your actual image import or path
  tags: [
    "Gemini GenAI",
    "SerpAPI",
    "MongoDB",
    "Node.js",
    "Web Scraping"
    
  ],
  category: "AI app",
  github: "https://github.com/vikash000x/new_stAI_thon",
  webapp: "https://new-staithon-frontend.onrender.com/"// Replace with your actual Render frontend URL  // Add this if you want to expose backend URL as well

},
          {
      id: 13,
      title: "TalentForge-AI",
      date: "september 2024 - december 2024",
      bg:"bg-slate-900 hover:bg-gradient-to-t from-black via-orange-700/50 to-orange-500/80 max-h-full p-6 w-[21rem] h-[42rem] rounded-lg m-5 text-white  md:w-[18rem] lg:w-[24rem] xl:w-[27rem] hover:shadow-md hover:shadow-slate-300/25 transform transition duration-500  hover:scale-105 ",
      description:
        "An AI-powered platform that helps users enhance their skills, generate resume, cover-letter, and examine your skill based on specified skills in user description also give interactive chat view of current market scenerio and trending skills  for career opportunities. ",
      image:image9,
      tags: [
        "React JS ",
        "Tailwind",
        "Redux",
        "Gemini API"
      ],
      category: "web",
      github: "https://github.com/vikash000x/TalentForge-AI",
      webapp: "https://talent-forge-ai.vercel.app/",
    },
    
  ];
  
  
